var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { createScoreboardProps, isEmptyObject } from "../../../helpers";
import { computed, observable, observe, action } from "mobx";
import { BlockCondition } from "sb-resp-block-lib";
export class SportScoreboardsState {
    constructor(options) {
        this.dict = options.dict;
        this.config = options.cms;
        this.uniqueBlockId = options.uniqueBlockId;
        this.parser = options.parser;
        this.condition = BlockCondition.LOADING;
    }
    activate() {
        this.disposer = observe(this.parser, "event", (change) => this.onUpdateEvent(change.newValue));
        this.parser.activate(this.uniqueBlockId);
    }
    deactivate() {
        this.disposer();
        this.parser.deactivate(this.uniqueBlockId);
    }
    onUpdateEvent(event) {
        isEmptyObject(event) ? this.changeCondition(BlockCondition.LOADING) : this.changeCondition(BlockCondition.LOADED);
    }
    changeCondition(cond) { this.condition = cond; }
    get isLoaded() { return this.condition === BlockCondition.LOADED; }
    get isLoading() { return this.condition === BlockCondition.LOADING; }
    get boardData() {
        return createScoreboardProps(this.parser.event, { dict: this.dict, cmsConfig: this.config });
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], SportScoreboardsState.prototype, "condition", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], SportScoreboardsState.prototype, "changeCondition", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SportScoreboardsState.prototype, "isLoaded", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SportScoreboardsState.prototype, "isLoading", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], SportScoreboardsState.prototype, "boardData", null);
//# sourceMappingURL=SportScoreboardsState.js.map